/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fast_True_Trout_GrowInputs */

const en_fast_true_trout_grow = /** @type {(inputs: Fast_True_Trout_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search keywords…`)
};

const de_fast_true_trout_grow = /** @type {(inputs: Fast_True_Trout_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keywords suchen…`)
};

/**
* | output |
* | --- |
* | "Search keywords…" |
*
* @param {Fast_True_Trout_GrowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fast_true_trout_grow = /** @type {((inputs?: Fast_True_Trout_GrowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fast_True_Trout_GrowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fast_true_trout_grow(inputs)
	return de_fast_true_trout_grow(inputs)
});